import { definePreset } from '@primeuix/themes';
import Material from '@primeuix/themes/material';

/**
 * Custom PrimeNG theme preset that aligns with Angular Material color primary palette.
 * *
 * Colors are mapped from the Angular Material theme CSS variables
 * defined in _mat-theme-color.scss
 *
 * @important SYNC REQUIREMENT:
 * The color values in this TypeScript file must be kept in sync with the
 * color definitions in `_mat-theme-color.scss` (the source of truth).
 *
 * Since TypeScript (.ts) and SCSS (.scss) files cannot directly import each other
 * due to language incompatibility, manual synchronization is required when colors
 * are updated. When modifying colors:
 * 1. Update the values in `_mat-theme-color.scss` first
 * 2. Update the corresponding hex values in this file to match
 * 3. Also update `styles.scss` if Angular Material palette definitions change
 *
 * The source of truth is: `projects/lemunzo-shared/src/assets/scss/_mat-theme-color.scss`
 */
export const LemunzoPrimeNGPreset = definePreset(Material, {
    semantic: {
        // Primary color palette - matches Angular Material primary
        primary: {
            50: '#fef2f2', // Lightest shade (generated)
            100: '#f0e7e8', // --clr-primary-100
            200: '#fce9eb', // --clr-primary-200
            300: '#b6182a', // --clr-primary-300
            400: '#8a1220', // Intermediate shade (generated)
            500: '#630d17', // --clr-primary-500 (main primary color)
            600: '#4d0a12', // Intermediate shade (generated)
            700: '#37080d', // Intermediate shade (generated)
            800: '#2a0609', // Intermediate shade (generated)
            900: '#450910', // --clr-primary-900
            950: '#2d060a', // Darkest shade (generated)
        },
    },
});
